import axios from 'axios';

// Get API base URL from environment variable or use relative path for same-origin
let API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// FORCE LOCALHOST if it's the placeholder URL (common issue if .env isn't updated or server not restarted)
if (API_BASE_URL.includes('your-railway-backend.railway.app')) {
  API_BASE_URL = 'http://localhost:5000/api';
}

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 second timeout to handle Railway cold starts
  headers: {
    'Content-Type': 'application/json',
  },
});

// Function to set up auth interceptor with Clerk
export const setupAuthInterceptor = (getToken) => {
  api.interceptors.request.use(
    async (config) => {
      try {
        const token = await getToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Error getting auth token:', error);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

// Response interceptor for handling auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      console.error('Unauthorized access - please sign in');
    }
    return Promise.reject(error);
  }
);

export default api;
